import { axiosGet } from '@/http/api'

/**
 * @description 【徐文涛】查看 已发布应用-简介
 */
export function getContentBrief(id) {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/app/apps/${id}/brief`)
      .then((res) => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}
